import React, { useRef, useState } from 'react'
import { AboutEl, RegistrationEl } from '../elements'
import { H3, H5, S1 } from '../../../../../../../../../../Styles/typography'
import { Link, withRouter } from 'react-router-dom'
import ShareIcon from '@material-ui/icons/Share'
import RecordedCourseDashboardStore from '../../../../../stores/RecordedCourseDashboardStore'
import Button from '../../../../../../../../../../Components/Buttons/Button'
import { motion } from 'framer-motion'
import { slowSpring } from '../../../config/animation'
import { Subscribe } from 'unstated'
import CourseStore from '../../../../../../../../Store/CourseStore'
import { useToggle } from 'react-use'
import { IconButton } from '@material-ui/core'
import Share from './share'
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline'
import useTime from '../../../../../../../../../../Helpers/CustomHooks/useTime'
import { accent } from '../../../../../../../../../../Styles/colors'
// import VideoPlayer from "./videoPlayer";

const About = ({
  history,
  location,
  match: {
    params: { courseURL },
  },
}) => {
  const now = useTime(5000)
  const player = useRef(false)
  const [showCover, toggleCover] = useState(true)
  const [displayShare, toggleShare] = useToggle(false)
  const {
    expanded,
    activeSubscription = [],
    toggleRegistrationModal,
  } = RecordedCourseDashboardStore.useContainer()

  const [disabled, toggle] = useToggle(false)
  return (
    <Subscribe to={[CourseStore]}>
      {({
        state: {
          name,
          teacher,
          livDemyID,
          coHosts=[],
          startTime,
          discount = 0,
          stdFee,
          userType,
          enrollments = [],
          allEnrollments = [],
          coverVideoUrl,
          cover,
          chapters,
          hasCertification = false,
        },
        enrollRecorded,
      }) => {
        const pendingRecordedEnrollment =
          enrollments[0]?.status === 'REGISTERED' &&
          enrollments[0]?.billStatus !== 'PAID'

        const enrolledInRecorded = enrollments[0]?.billStatus === 'PAID'
        const paidEnrollments = allEnrollments.filter((enrollment) => {
          return enrollment.billStatus === 'PAID'
        })
        const sortedPaidEnrollments = paidEnrollments.sort((a, b) => {
          return new Date(b.paidAt) - new Date(a.paidAt)
        })
        const lastPaidEnrollment = sortedPaidEnrollments[0]

        const lastEnrollment = allEnrollments?.[0]

        const needUpgrade =
          (lastPaidEnrollment?.billStatus === 'PAID' &&
            !(
              lastPaidEnrollment?.paidAt > Date.now() - 1000 * 60 * 60 * 1 ||
              (lastPaidEnrollment?.sessionCount || 0) < 2
            )) ||
          !lastPaidEnrollment?.registrationType ||
          lastPaidEnrollment?.registrationType === 'STANDARD' ||
          (lastEnrollment?.registrationType === 'UPGRADE' &&
            lastEnrollment?.billStatus !== 'PAID')
        const PendingUpgrade =
          lastEnrollment?.billStatus !== 'PAID' &&
          lastEnrollment?.registrationType === 'UPGRADE'

        const nextChapterLink = `/${livDemyID}/course/${courseURL}/chapter/${chapters[0].id}/lesson/${chapters[0].lessons[0].id}`

        const subscriptionDiscount = (() =>
          activeSubscription[0]?.discounts?.recordedCourse || 0)()

        const finalDiscount = (() => {
          return discount + ((100 - discount) * subscriptionDiscount) / 100
        })()
        return (
          <AboutEl expanded={expanded}>
            {!expanded && (
              <div className='video'>
                <div className='vid-container'>
                  <motion.video
                    onContextMenu={(e) => e.preventDefault()}
                    ref={player}
                    layoutId='coverVideo'
                    transition={slowSpring}
                    src={coverVideoUrl}
                    controls
                    controlsList='nodownload'
                  />
                  {showCover && (
                    <motion.div
                      className='cover'
                      style={{
                        background: `url(${cover}) center center /cover no-repeat`,
                      }}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 0.5 }}
                    >
                      <div
                        className='playIcon'
                        onClick={() => {
                          toggleCover(false)

                          player.current.play()
                        }}
                      >
                        <PlayCircleOutlineIcon />
                      </div>
                    </motion.div>
                  )}
                </div>
              </div>
            )}
            {displayShare && <Share close={() => toggleShare(false)} />}
            <motion.div
              layout
              className='info'
              animate={{
                scale: expanded ? 1 : 0.768,
                x: expanded ? '0px' : '-64px',
                y: expanded ? '0px' : '-16px',
                transformOrigin: `0 0`,
              }}
              transition={slowSpring}
            >
              <H3 bold>{name}</H3>
              <H5 style={{display:'flex'}}>
                <Link to={`/${livDemyID}`} style={{ color: accent }}>
                  {teacher?.name}
                </Link>
                <div style={{ display: 'flex', marginLeft: 8 }}>
                  {Boolean(coHosts.length) && <span>with</span>}
                {coHosts.map((coHost, index) => (
                  <div key={index}>
                  <Link to={`/${coHost.livdemyId}`} style={{
                    color: accent,
                    marginLeft: 8
                  }}>
                    {coHost.name}
                  </Link>
                  {index < coHosts.length - 1 && <span>,</span>}
                    </div>
                ))}
                </div>
              </H5>
            </motion.div>
            <div className='right'>
              {expanded ? (
                <div className='rating'>
                  <IconButton
                    style={{ color: 'black' }}
                    onClick={() => toggleShare(true)}
                  >
                    <ShareIcon fontSize={'small'} />
                  </IconButton>
                </div>
              ) : (
                <RegistrationEl
                  layout
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                >
                  <div className='fee'>
                    {Boolean(finalDiscount) && (
                      <S1 className='original'>
                        <span className='percentOff'>
                          ({finalDiscount}% off)
                        </span>
                        <span className='originalAmount'>
                          {stdFee?.currency} {stdFee?.amount}
                        </span>
                      </S1>
                    )}
                    <div className='final'>
                      {Boolean(finalDiscount) ? (
                        <H3 bold>
                          {stdFee?.currency}{' '}
                          {Math.round(
                            stdFee.amount * (1 - finalDiscount / 100) * 100,
                          ) / 100}
                        </H3>
                      ) : (
                        <H3 bold>
                          {stdFee?.currency} {stdFee?.amount}
                        </H3>
                      )}
                    </div>
                  </div>
                  <div className='actions'>
                    {(enrolledInRecorded || userType === 'teacher') &&
                    now > startTime ? (
                      <Link to={nextChapterLink}>
                        <Button
                          onClick={() => {}}
                          name='Start Watching'
                          type='primary'
                        />
                      </Link>
                    ) : (
                      <Button
                        onClick={async () => {
                          if (userType === 'anonymous') {
                            history.push({
                              pathname: '/auth/login',
                              state: { from: location },
                            })
                          } else if (pendingRecordedEnrollment) {
                            history.push(
                              `/billing/payment/${enrollments[0]?.billId}`,
                            )
                          } else {
                            toggleRegistrationModal(true)
                          }
                        }}
                        type='primary'
                        name={
                          enrolledInRecorded
                            ? 'Registered'
                            : pendingRecordedEnrollment
                            ? 'Complete Registration'
                            : 'Register'
                        }
                        disabled={enrolledInRecorded || userType === 'teacher'}
                        requiresLogin
                      />
                    )}

                    {needUpgrade && hasCertification && enrolledInRecorded ? (
                      <Button
                        onClick={async () => {
                          if (userType === 'anonymous') {
                            history.push({
                              pathname: '/auth/login',
                              state: { from: location },
                            })
                          } else if (PendingUpgrade) {
                            history.push(
                              `/billing/payment/${lastEnrollment?.billId}`,
                            )
                          } else {
                            toggle(true)
                            const success = await enrollRecorded('UPGRADE')
                            if (success) {
                              history.push(`/billing/payment/${success.billId}`)
                            }
                            toggle(false)
                          }
                        }}
                        type='primary'
                        name={PendingUpgrade ? 'Complete Upgrade' : 'Upgrade'}
                        disabled={
                          !needUpgrade || userType === 'teacher' || disabled
                        }
                        requiresLogin
                      />
                    ) : (
                      <></>
                    )}
                    {userType === 'teacher' && (
                      <Link
                        to={`/${livDemyID}/course/${courseURL}/review-submissions`}
                      >
                        <Button
                          onClick={() => {}}
                          name='Review Submissions'
                          type='primary'
                        />
                      </Link>
                    )}
                  </div>
                </RegistrationEl>
              )}
            </div>
          </AboutEl>
        )
      }}
    </Subscribe>
  )
}

export default withRouter(About)
